/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Last_YearInputs */

const en_ui_filter_last_year = /** @type {(inputs: Ui_Filter_Last_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`last year`)
};

const de_ui_filter_last_year = /** @type {(inputs: Ui_Filter_Last_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letztes Jahr`)
};

/**
* | output |
* | --- |
* | "last year" |
*
* @param {Ui_Filter_Last_YearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_year = /** @type {((inputs?: Ui_Filter_Last_YearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_YearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_year(inputs)
	return de_ui_filter_last_year(inputs)
});